import { useMe } from '@/hooks/use-me';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingState } from './LoadingState';

/**
 * Renders <Navigate to="/404"> when the caller is NOT an admin (super or
 * company). Used to gate /admin/* without leaking the route's existence
 * to non-admins.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { data, isPending } = useMe();
  if (isPending) return <LoadingState />;
  const isAdmin = !!(data?.user.is_super_admin || data?.user.company_admin);
  if (!isAdmin) return <Navigate to="/404" replace />;
  return <>{children}</>;
}

/**
 * Super-admin only. Mirrors RequireAdmin behaviour.
 */
export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { data, isPending } = useMe();
  if (isPending) return <LoadingState />;
  if (!data?.user.is_super_admin) return <Navigate to="/404" replace />;
  return <>{children}</>;
}
